import debounce from '../utils/debounce';

const PADDING = 60;

export default class Article {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) throw new Error('Article not found');

        const navs = el.querySelectorAll(`${query}--navigation-list.desktop a`);
        if (!navs || !navs.length) throw new Error('Article navigation not found');

        const mNavs = el.querySelectorAll(`${query}--navigation-list.mobile a`);
        if (!mNavs || !mNavs.length) throw new Error('Article navigation not found');

        const dropdown = document.querySelector(`${query}--dropdown`);
        if (!dropdown) throw new Error('Article navigation not found');

        const dText = dropdown.querySelector(`${query}--dropdown-text`);
        if (!dText) throw new Error('Article navigation not found');

        const sections = el.querySelectorAll(`${query}--section`);
        if (!sections || !sections.length) throw new Error('Article sections not found');

        this.query = query;
        this.el = el;
        this.navs = [...navs];
        this.mNavs = [...mNavs];
        this.sections = [...sections];
        this.dropdown = dropdown;
        this.dText = dText;

        this.fix = document.querySelector('.site-header').offsetHeight;

        this.positions = [];

        this.init();
    }

    init () {
        this.setFix();
        this.setScroll();
        this.setNavs();

        this.setupDropdown();
    }

    setFix () {
        window.addEventListener('resize', () => {
            this.fix = document.querySelector('.site-header').offsetHeight;
        });
    }

    setScroll () {
        this.navs[0].classList.add('active');
        this.mNavs[0].classList.add('active');

        this.sections.forEach((section) => {
            this.positions.push({
                id: section.getAttribute('id'),
                position: section.offsetTop
            });
        });

        window.addEventListener('resize', () => {
            this.positions = [];

            this.sections.forEach((section) => {
                this.positions.push({
                    id: section.getAttribute('id'),
                    position: section.offsetTop
                });
            });
        });

        const scroll = () => {
            const scrollPos = window.scrollY;

            for (let i = 0; i < this.positions.length; i++) {
                let anchor = this.positions[i].position - this.fix - PADDING;

                if (window.innerWidth <= 991) {
                    anchor = this.positions[i].position - 200;
                }

                if (scrollPos >= anchor) {
                    this.navs.forEach((nav) => nav.classList.remove('active'));
                    this.mNavs.forEach((nav) => nav.classList.remove('active'));

                    this.navs[i].classList.add('active');
                    this.mNavs[i].classList.add('active');

                    this.dText.textContent = this.mNavs[i].textContent;
                } else {
                    if (i > 0) {
                        this.navs[i].classList.remove('active');
                        this.mNavs[i].classList.remove('active');
                    }
                }
            }
        }

        window.addEventListener('scroll', debounce(scroll, 0));
    }

    setNavs () {
        [...this.navs, ...this.mNavs].forEach((nav) => {
            nav.addEventListener('click', (event) => {
                event.preventDefault();

                const target = nav.getAttribute('href').slice(1);
                const position = this.positions.filter((s) => s.id === target)[0];

                if (!position) return;

                if (window.innerWidth > 991) {
                    window.scrollTo({ left: 0, top: position.position - this.fix, behavior: 'smooth' });
                } else {
                    window.scrollTo({ left: 0, top: position.position - 124, behavior: 'smooth' });
                }
            });
        });
    }

    setupDropdown () {
        this.dText.textContent = this.mNavs[0].textContent;

        const trigger = this.dropdown.querySelector(`${this.query}--dropdown-trigger`);
        const list = this.dropdown.querySelector(`${this.query}--dropdown-list`);

        const calulate = () => {
            list.style.maxHeight = 'none';

            const height = list.scrollHeight;

            list.style.maxHeight = 0;

            return height;
        }

        const toggle = (state) => {
            if (!state) {
                this.dropdown.classList.remove('collapsed');

                setTimeout(() => list.style.maxHeight = 0, 100);
            } else {
                const height = calulate();

                this.dropdown.classList.add('collapsed');

                setTimeout(() => list.style.maxHeight = `${height}px`, 100);
            }
        }

        window.addEventListener('click', (event) => {
            event.stopPropagation();

            toggle(false);
        });

        trigger.addEventListener('click', (event) => {
            event.stopPropagation();

            toggle(!this.dropdown.classList.contains('collapsed'));
        });

        Array.from(list.querySelectorAll('a')).forEach((item) => {
            item.addEventListener('click', (event) => {
                event.stopPropagation();
    
                setTimeout(() => toggle(false), 100);
            });
        });
    }
}
